import React, {Component} from 'react';
import FieldLabel from './field-label';

class UpdateFunction extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  onChange(key, value) {
    this.setState((prevState, props) => {
      const newValue = { ...prevState.value };
      newValue[key] = value;
      props.onChange(newValue);
      return { value: newValue };
    });
  }

  render() {
    return <>
      <div className="col-12">
        <div className="form-check">
          <input type="checkbox"
                 id={this.props.id + 'HiddenFieldEnabled'}
                 className="form-check-input"
                 checked={!!this.state.value.enabled}
                 onChange={e => this.onChange('enabled', e.target.checked)} />
          <label className="form-check-label" htmlFor={this.props.id + 'HiddenFieldEnabled'}>
            Expose a function to update the field value
          </label>
        </div>
        {this.state.value.enabled &&
          <div className="ms-md-4 mb-3">
            <label htmlFor="updateFunctionName" className="form-label">Function name</label>
            <input id="updateFunctionName" name="updateFunctionName"
                   type="text"
                   className="form-control"
                   placeholder="e.g. updateMyField"
                   value={this.state.value.functionName || ''}
                   onChange={e => this.onChange('functionName', e.target.value)}/>
            <div className="form-text">
              To update the field, use <code>window.{this.state.value.functionName || 'updateMyField'}(&apos;some value&apos;)</code> in your code
            </div>
          </div>
        }
      </div>
    </>
  }

}

export default class HiddenField extends Component {

  constructor(props) {
    super(props);
    this.state = {
      model: props.model,
    };
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = { ...prevState.model };
        model[fieldName] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <div className="row">
      <div className="col-12">
        <FieldLabel value={this.state.model.label} onChange={v => this.updateModel('label', v)} />
      </div>
      <div className="col-12">
        <div className="mb-3">
          <label htmlFor="javascriptForValue" className="form-label">Javascript</label>
          <textarea id="javascriptForValue" name="javascriptForValue"
                    className="form-control"
                    style={{ minHeight: '7em' }}
                    value={this.state.model.javascriptForValue || ''}
                    onChange={e => this.updateModel('javascriptForValue', e.target.value)} />
          <div className="form-text">
            Javascript code run on the page to determine the value of this field.<br />
            The last statement is used as a value.<br />
            For example this code would populate the field with 4 as a value:<br/>
            <pre>
              let result = 2;<br />
              result = result * result;<br />
              result;
            </pre>
            Promises can also be returned (i.e. <code>new Promise(function(resolve) &#123;...&#125;);</code>)
          </div>
        </div>
      </div>
      <UpdateFunction id={this.props.id}
                      value={this.state.model.updateFunction || {}}
                      onChange={value => this.updateModel('updateFunction', value)}/>
    </div>
  }

}
